import React from 'react';
import {makeStyles} from "@material-ui/core/styles";

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '33%',
        margin: theme.spacing(3)
    },
    header: {
        margin: '1rem'
    },
    body: {
        margin: '2rem 0',
        padding: '2rem 0'
    },
    statStyle: {
        textAlign: 'center',
    },
    link: {
        float: 'right'
    }
}));

export default function StatCard({ title, value, link }) {
    const classes = useStyles();

    const handleClickForLink = () => {
        if (link) {
            window.open(link, "_blank");
        }
    }

    return (
        <Paper className={`${classes.root} ${!link && classes.statStyle}`}
               elevation={3}
               onClick={handleClickForLink}>
            <Typography className={classes.header} variant='h6'>
                {title}
                {link && <OpenInNewIcon className={classes.link}/>}
            </Typography>
            <Typography className={`${classes.body} ${link && classes.statStyle}`} variant='h4'>
                {value}
            </Typography>
        </Paper>
    );
}
